/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LatestShiftResponse } from '../models/LatestShiftResponse';
import type { LatestShiftSaveRequest } from '../models/LatestShiftSaveRequest';
import type { ShiftPresetListResponse } from '../models/ShiftPresetListResponse';
import type { ShiftPresetSaveRequest } from '../models/ShiftPresetSaveRequest';
import type { ShiftPresetSaveResponse } from '../models/ShiftPresetSaveResponse';
import type { StaffDataRequest } from '../models/StaffDataRequest';
import type { StaffDataResponse } from '../models/StaffDataResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StaffService {
    /**
     * Get Staff
     * @returns StaffDataResponse Successful Response
     * @throws ApiError
     */
    public static getStaff(): CancelablePromise<StaffDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/staff',
        });
    }
    /**
     * Save Staff
     * @param requestBody
     * @returns StaffDataResponse Successful Response
     * @throws ApiError
     */
    public static saveStaff(
        requestBody: StaffDataRequest,
    ): CancelablePromise<StaffDataResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/staff',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * シフトプリセット一覧を取得
     * @returns ShiftPresetListResponse Successful Response
     * @throws ApiError
     */
    public static listShiftPresets(): CancelablePromise<ShiftPresetListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/shift-presets',
        });
    }
    /**
     * シフトプリセットを保存（新規作成）
     * @param requestBody
     * @returns ShiftPresetSaveResponse Successful Response
     * @throws ApiError
     */
    public static saveShiftPreset(
        requestBody: ShiftPresetSaveRequest,
    ): CancelablePromise<ShiftPresetSaveResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/shift-presets',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * シフトプリセットを上書き保存
     * @param presetId
     * @param requestBody
     * @returns ShiftPresetSaveResponse Successful Response
     * @throws ApiError
     */
    public static updateShiftPreset(
        presetId: string,
        requestBody: ShiftPresetSaveRequest,
    ): CancelablePromise<ShiftPresetSaveResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/shift-presets/{preset_id}',
            path: {
                'preset_id': presetId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * シフトプリセットを削除
     * @param presetId
     * @returns void
     * @throws ApiError
     */
    public static deleteShiftPreset(
        presetId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/shift-presets/{preset_id}',
            path: {
                'preset_id': presetId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 最新シフト（曜日別）を取得
     * @returns LatestShiftResponse Successful Response
     * @throws ApiError
     */
    public static getLatestShift(): CancelablePromise<LatestShiftResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/latest-shift',
        });
    }
    /**
     * 最新シフト（曜日別）を保存
     * @param requestBody
     * @returns LatestShiftResponse Successful Response
     * @throws ApiError
     */
    public static saveLatestShift(
        requestBody: LatestShiftSaveRequest,
    ): CancelablePromise<LatestShiftResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/latest-shift',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
